import { createSlice } from '@reduxjs/toolkit';
import { filterFlyAshData } from 'services/filterFlyAshData';

// ** Initial State
const initialState = {
  data: [],
  pageData: [],
  filteredData: {},
  totalAccuracy: 0,
  file: { type: 'img', url: '' }
};

// ** Reducer
const flyAsh = createSlice({
  name: 'flyAsh',
  initialState,
  reducers: {
    setFlyAshData: (state, action) => {
      const billData = action.payload;
      const filterInvoice = filterFlyAshData(billData);
      state.data = filterInvoice.data;

      let filteredData = { ...filterInvoice.filteredData };

      state.filteredData = filteredData;
    },
    setFlyAshPageData: (state, action) => {
      state.pageData = action.payload;
    },
    setFlyAshFile: (state, action) => {
      state.file = action.payload;
    },
    setFlyAshTotalAccuracy: (state, action) => {
      state.totalAccuracy = action.payload;
    }
  }
});

export const {
  setFlyAshData,
  setFlyAshPageData,
  setFlyAshFile,
  setFlyAshTotalAccuracy
} = flyAsh.actions;

export default flyAsh.reducer;
